import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "msi-form" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = { class: "msi-content" }
const _hoisted_5 = { class: "header" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("批量打印选中项")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createTextVNode("选择出库口:")
const _hoisted_10 = { class: "dialog-footer" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_13 = { class: "slot_title" }
const _hoisted_14 = { class: "title_orderNo" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", null, "盘点详情", -1)
const _hoisted_16 = {
  class: "msi-content",
  style: {"margin-top":"0px","padding-top":"0"}
}

import {ref,reactive} from 'vue'
import {getOutPage,delOutOrder,outerConfirm,getWareSite,getOutDetailPage} from '@/service/main/invoices'
import {getCheckReportPage,getCheckReportDetail} from '@/service/main/check/checkStatement'
import {getClaimPage,getClaimDetailPage} from '@/service/main/invoices'
import { ElMessage, ElMessageBox } from 'element-plus';
import { exportExcel } from "@/utils/exportExcel";
import {amountFormat,formatUtcToData} from '@/utils/formate'
import Pagination from '@/components/Pagination/index.vue'
  //盘点盈亏平获取
  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const getCheckResult = (count: number): string => {
    if(count > 0) {
      return '盘盈'
    }else if(count < 0) {
      return '盘亏'
    }else {
      return '平'
    }
  }
    //盘点单详情
    const detailForm = ref({
        OrderId: '',
        PageNo: 1,
        PageSize: 10
    })

    // 物料详情抽屉
    const drawerVisible = ref(false);

    //采购单号
    const orderNo = ref('');

    //打开抽屉
    const openDrawer = (scope: any = {}) => {
      //当前入库单号id
      detailForm.value.OrderId = scope.id;
      //出库单号
      orderNo.value = scope.orderNo;
      //获取物料列表
      getDetail();
      drawerVisible.value = true;
    }

    //关闭抽屉
    const handleDrawerClose = () => {
      detailForm.value = {
        OrderId: '',
        PageNo: 1,
        PageSize: 10
      }

      deltailList.value = [];
      detailCount.value = 0;

    }

    //入库单详情列表
    const deltailList = ref<any[]>([]);

    //入库单详情列表数据条数
    const detailCount = ref(0);

    //获取入库单下物料详情
    const getDetail = () => {
        getCheckReportDetail(detailForm.value).then(res =>{
            if(res.code == 200) {
                const {data} = res;
                const result = data;
                deltailList.value = result.rows;
                detailCount.value = result.totalRows;
            }else {
                ElMessage.error(JSON.stringify(`获取盘点单详情失败${res.code}:${JSON.stringify(res.message)}`));
            }
        }).catch(err => ElMessage.error(JSON.stringify(err)))
    }
// -----------盘点差异列表---------------------
    //查询
    const formModel = ref({
      OrderNo: '',
      BeginDate: '',
      EndDate: '',
      CreateTime: [],
      PageNo: 1,
      PageSize: 10
    });

    //列表数据
    let tableData = ref([]);

    //列表的数据条数
    const totalItems = ref<number>(0);

    //取货单列表获取
    const getTabelData = () => {
        //判断用户是否选择了时间
        if(formModel.value.CreateTime.length > 0) {
            formModel.value.BeginDate = formModel.value.CreateTime[0];
            formModel.value.EndDate = formModel.value.CreateTime[1];
        }

        getCheckReportPage(formModel.value).then(res => {
            if(res.code == 200) {
            const {data} = res;
            const result = data;
            tableData.value = result.rows;
            totalItems.value = result.totalRows;
            }else {
            ElMessage.error(`${res.code}:${JSON.stringify(res.message)}`)
            } 
        }).catch(err => {
            console.log(err)
            ElMessage.error(JSON.stringify(err))
        })
    }

    getTabelData();

    //重置搜索
    const resetForm = () => {
      formModel.value = {
        OrderNo: '',
        BeginDate: '',
        EndDate: '',
        CreateTime: [],
        PageNo: 1,
        PageSize: 10
      }
      getTabelData();
    }

    //选中的行
    const checkRows = ref<{wareContainerCode:string}[]>([]);

    // 选择
    const handleSelectionChange = (val: any) => {
      checkRows.value = val;
    }
    //导出
    const handExport = () => {
      let entozh = {
          id: "序号",
          orderNo: "盘点单号",
          ruleName: "规则名称",
          ruleRate: '盘点比例',
          statusName: '盘点进度',
          totalLocation: '总盘点库位',
          totalMaterial: "总盘点物料",
          countedMaterial: "已盘点物料",
          planDate: '盘点日期'
        };
      exportExcel(checkRows.value, entozh, "xlsx", `盘点报表${formatUtcToData(new Date().toString(),'YYYY-MM-DD hh:mm:ss')}`);
    }

    //打印
    const printTable = () => {
      
      print({
        printable: checkRows.value,
        type: 'json',
        properties: [
          { field: 'orderNo', displayName: '盘点单号'},
          { field: 'ruleName', displayName: '规则名称'},
          { field: 'ruleRate', displayName: '盘点比例'},
          { field: 'statusName', displayName: '平单间进度'},
          { field: 'totalLocation', displayName: '总盘点库位'},
          { field: 'totalMaterial', displayName: '总盘点物料'},
          { field: 'countedMaterial', displayName: '已盘点物料'},
          { field: 'planDate', displayName: '盘点日期'}

        ],
        header: '<h3 style="text-align: center;">盘点报表</h3>',
        sytle: '.custom-h3 { color: red; }'
      })
    }


    //删除
    const deleteRole = (order: string) => {
      ElMessageBox.confirm('是否确认删除？','提示',{
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delOutOrder({orderNo: [order]}).then((res: any) => {
          if(res?.code === 200) {
            ElMessage.success('删除成功')
            // 刷新列表
            getTabelData()
          }else {
            ElMessage.error(`删除失败${res?.code}:${JSON.stringify(res.message)}`)
          }
        }).catch((err: any) => {
          console.log(err);
          ElMessage.error(`删除失败${err}`)
        })
      }).catch(() =>{
        ElMessage.info('已取消删除')
      })
    }

    const dialogVisible = ref(false);
    
    //操作表单ref
    const dialogRef = ref();

    //站点数据
    const wareSiteList = ref<{code: string,name: string}[]>([]);
    
    //获取站点列表
    const getWareSitePage = () => {
      getWareSite({PageSize: 1000,PageNo: 1}).then(res => {
        if(res.code == 200) {
          const {data} = res;
          const result = data;
          //只有入口、和出入口才能被使用
          wareSiteList.value = result.rows.filter((item: { siteType: number; }) => item.siteType == 0 || item.siteType == 2);
        }else {
          ElMessage.error(`${res.code}:${JSON.stringify(res.message)}`)
        }
      }).catch(err => ElMessage.error(JSON.stringify(err)))
    }

    //出库的请求参数
    const outerForm = ref({
      gate: '',
      orderNo: ''
    })

    //打开出库窗口
    const openDialog  = (orderNo: string) => {
      //获取出库口
      getWareSitePage();
      outerForm.value.orderNo = orderNo;
      dialogVisible.value = true;
    }

    //关闭出库窗口的回调
    const closeOutDialog = () => {
      outerForm.value.orderNo = '';
      wareSiteList.value = []
    }
    //确认出库
    const confirm = () => {
      if(outerForm.value.gate) {
        outerConfirm(outerForm.value).then(res => {
          if(res.code == 200) {
            ElMessage.success('下发成功');
            dialogVisible.value = false;
            getTabelData();
          }else {
            ElMessage.error(`下发失败${res?.code}:${JSON.stringify(res.message)}`)
          }
        }).catch(err => {
          console.log(err);
          ElMessage.error(JSON.stringify(err))
        })
      }else {
        ElMessage.warning('请选择出库口');
      }
      
    }

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        model: formModel.value,
        "label-width": "120px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "盘点单号:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formModel.value.OrderNo,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formModel.value.OrderNo) = $event)),
                        clearable: "",
                        placeholder: "请输入盘点单号"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "盘点时间:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: formModel.value.CreateTime,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formModel.value.CreateTime) = $event)),
                        type: "daterange",
                        "range-separator": "至",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        "value-format": "YYYY-MM-DD",
                        style: {"width":"100%"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 4 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { "label-width": "40px" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        icon: "el-icon-search",
                        onClick: getTabelData
                      }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        icon: "el-icon-refresh-right",
                        onClick: resetForm
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            type: "info",
            icon: "iconfont icon-biaoqianguanli",
            plain: "",
            disabled: checkRows.value.length == 0,
            onClick: printTable
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            type: "info",
            plain: "",
            icon: "el-icon-upload2",
            disabled: checkRows.value.length == 0,
            onClick: handExport
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _createVNode(_component_el_table, {
        data: _unref(tableData),
        border: "",
        style: {"width":"100%"},
        onSelectionChange: handleSelectionChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            align: "center",
            width: "60",
            type: "selection"
          }),
          _createVNode(_component_el_table_column, {
            label: "序号",
            align: "center",
            width: "60",
            type: "index"
          }),
          _createVNode(_component_el_table_column, {
            label: "盘点单号",
            align: "center",
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", {
                class: "under_line",
                onClick: ($event: any) => (openDrawer(scope.row))
              }, _toDisplayString(scope.row.orderNo), 9, _hoisted_8)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "规则名称",
            prop: "ruleName",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "盘点比例",
            prop: "ruleRate",
            align: "center",
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.ruleRate) + "% ", 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "盘点进度",
            prop: "statusName",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "总盘点物料数",
            prop: "totalMaterial",
            sortable: "",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "已盘点物料数",
            prop: "countedMaterial",
            sortable: "",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "总盘点库位",
            prop: "totalLocation",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "盘点日期",
            prop: "planDate",
            align: "center",
            "show-overflow-tooltip": ""
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createVNode(Pagination, {
        total: totalItems.value,
        page: formModel.value.PageNo,
        "onUpdate:page": _cache[2] || (_cache[2] = ($event: any) => ((formModel.value.PageNo) = $event)),
        limit: formModel.value.PageSize,
        "onUpdate:limit": _cache[3] || (_cache[3] = ($event: any) => ((formModel.value.PageSize) = $event)),
        onPagination: getTabelData,
        style: {"margin-top":"20px","text-align":"center"}
      }, null, 8, ["total", "page", "limit"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((dialogVisible).value = $event)),
      title: "出库口",
      width: "40%",
      onClose: closeOutDialog
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_10, [
          _createVNode(_component_el_button, {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: confirm
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_row, { style: {"font-size":"16px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 4,
              offset: 1
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 18 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: outerForm.value.gate,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((outerForm.value.gate) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(wareSiteList.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_radio, {
                        key: item.code,
                        label: item.code,
                        style: {"margin-bottom":"10px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_drawer, {
      modelValue: drawerVisible.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((drawerVisible).value = $event)),
      title: "盘点详情",
      direction: "rtl",
      size: "80%",
      onClose: handleDrawerClose
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, _toDisplayString(orderNo.value), 1),
          _hoisted_15
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_el_table, {
            data: deltailList.value,
            border: "",
            striped: "",
            "row-key": "id",
            style: {"width":"99%","margin":"0 auto"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, { type: "expand" }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_form, {
                    "label-position": "left",
                    "label-width": "180px",
                    inline: "",
                    class: "demo-table-expand"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "大类" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(scope.row.wareMaterialCategoryName), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_form_item, { label: "小类" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(scope.row.wareMaterialTypeName), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_form_item, { label: "所属仓库" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(scope.row.wareStorehouseName), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_form_item, { label: "所属库区" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(scope.row.wareRegionName), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_form_item, { label: "所属货架" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(scope.row.wareShelvesName), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_form_item, { label: "所属库位" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(scope.row.wareLocationName), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_form_item, { label: "所属库位" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(scope.row.wareLocationName), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_form_item, { label: "容器编号" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(scope.row.wareContainerCode), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_form_item, { label: "单位" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(scope.row.unit), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_form_item, { label: "备注" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(scope.row.checkRemarks), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "序号",
                align: "center",
                width: "60",
                type: "index"
              }),
              _createVNode(_component_el_table_column, {
                label: "物料编号",
                prop: "wareMaterialCode",
                align: "center",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "物料名称",
                prop: "wareMaterialName",
                align: "center",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "批次",
                prop: "batchNo",
                align: "center",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "库存数",
                prop: "quantity",
                align: "center",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "实盘数",
                prop: "checkQuantity",
                align: "center",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "差异数量",
                align: "center",
                "show-overflow-tooltip": ""
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(parseInt(scope.row.checkQuantity)  - parseInt(scope.row.quantity)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "价格",
                align: "center",
                "show-overflow-tooltip": ""
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(_unref(amountFormat)(scope.row.price,2,false)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "总价",
                align: "center",
                "show-overflow-tooltip": ""
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(_unref(amountFormat)(scope.row.price * scope.row.checkQuantity,2,false)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "差异金额",
                align: "center",
                "show-overflow-tooltip": ""
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(_unref(amountFormat)(scope.row.price * (scope.row.checkQuantity - scope.row.quantity),2,false)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "盘点结果",
                align: "center",
                "show-overflow-tooltip": ""
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(getCheckResult(scope.row.checkQuantity - scope.row.quantity)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"]),
          _createVNode(Pagination, {
            total: detailCount.value,
            page: detailForm.value.PageNo,
            "onUpdate:page": _cache[7] || (_cache[7] = ($event: any) => ((detailForm.value.PageNo) = $event)),
            limit: detailForm.value.PageSize,
            "onUpdate:limit": _cache[8] || (_cache[8] = ($event: any) => ((detailForm.value.PageSize) = $event)),
            onPagination: getDetail,
            style: {"margin-top":"20px","text-align":"center"}
          }, null, 8, ["total", "page", "limit"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})